import { Component, input } from '@angular/core';
import { OnyxNamePipe } from '@onyx/angular';
import type { SimplifiedDriver } from '../../../../../drivers/common/interfaces/driver';

@Component({
  selector: 'app-base-driver-cell',
  imports: [OnyxNamePipe],
  templateUrl: './base-driver-cell.component.html',
  styleUrl: './base-driver-cell.component.scss',
})
export class BaseDriverCellComponent {
  public readonly driver = input.required<SimplifiedDriver | null>();
}
